import React from "react";
import { useLocalization } from "../localization/LocalizationContext";

const LoginBrandPanel = () => {
  const { localizationStrings } = useLocalization();

  return (
    <aside className="login-brand-panel">
      <div className="login-brand-panel-inner">
        <p className="login-kicker">Network Management System</p>
        <h2>INC Platform</h2>
        <p className="login-brand-copy">{localizationStrings?.getMoreINC}</p>
        <ul className="login-highlights">
          <li>Device inventory, health, and topology</li>
          <li>Wired and wireless configuration</li>
          <li>Alerts, audits, OTA, SNMP, and TR-069</li>
        </ul>
      </div>
    </aside>
  );
};

export default LoginBrandPanel;
